<div class="payment-success">
  <nx-ng-success-indicator
    [labelKey]="'payment_success_text'"
  ></nx-ng-success-indicator>
</div>
